module.exports = __webpack_public_path__ + "img/pc.bce27308.svg";